@if(loaded()){
<ng-content></ng-content>
}
